import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProgressSpinner from '../../material/ProgressSpinner';
import Chart from './Chart';

export default class PeriscopeChart extends Component {

  static propTypes = {
    chartSourceUrl: PropTypes.string.isRequired,
    padding: PropTypes.string,
    style: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.showChart = this.showChart.bind(this);
    this.receiveMessage = this.receiveMessage.bind(this);
    this.chartSourceUrl = props.chartSourceUrl;

    /*
      The iframe needs to be attached to the page in order for the
      Periscope request to occur. Once the iframe renders with the Periscope
      charting data a 'PostMessage' event is fired that emits data that pertains
      to the ideal size of the iframe which we use for styling purposes.
    */

    this.state = {
      hasLoaded: false,
      iframeVisibility: 'hidden',
      iframeHeight: '500px'
    }

    window.addEventListener('message', this.receiveMessage, false);
  }

  receiveMessage(event) {
    if (event.origin === 'https://app.periscopedata.com' &&
      event.data.event_type === 'dashboard_resize') {

      this.setState({
        hasLoaded: true,
        iframeHeight: (event.data.dashboard_height + 50) + 'px',
        iframeVisibility: 'initial'
      });
    }
  }

  render() {
    return (
      <div>
        {!this.state.hasLoaded && this.showPreloader()}
        {this.showChart()}
      </div>
    )
  }

  showPreloader() {
    const style = {
      textAlign: 'center'
    }

    return (
      <div style={{ ...style, ...this.props.style }}>
        <ProgressSpinner classNames={"preloader pl-xxl pls-blue"} />
      </div>
    )
  }

  showChart() {
    const { padding } = this.props;
    const chartStyle = {
      border: 'none',
      width: '100%',
      overflow: 'hidden',
      visibility: this.state.iframeVisibility,
      height: this.state.iframeHeight
    };
    if (padding) {
      chartStyle.padding = padding;
    }

    return <Chart chartSourceUrl={this.chartSourceUrl} chartStyle={chartStyle} />;
  }
}
